import './HintBubble.css';

/**
 * Speech-bubble onboarding hint. Permanently dismissed when clicked.
 * Must be rendered inside a `position: relative` container.
 *
 * @param {{
 *   text: string,
 *   onDismiss: () => void,
 *   anchor: 'below'|'right-from-bottom'|'right-from-top'|'eq-right'
 * }} props
 */
export default function HintBubble({ text, onDismiss, anchor = 'below' }) {
  return (
    <div
      className={`hint-bubble hint-bubble--${anchor}`}
      onPointerDown={e => { e.stopPropagation(); onDismiss(); }}
      role="note"
    >
      {text}
    </div>
  );
}
